module.exports = __webpack_public_path__ + "img/boxes.642bf142.svg";